import { Link } from "react-router-dom";
import type { WorkType } from "@/types/media";

interface CategoryEntry {
  type: WorkType;
  title: string;
  desc: string;
  icon: string;
  image: string;
}

const entries: CategoryEntry[] = [
  {
    type: "movie",
    title: "电影频道",
    desc: "院线大片 · 经典佳片",
    icon: "ri-film-line",
    image:
      "https://readdy.ai/api/search-image?query=warm%20vintage%20cinema%20interior%20with%20rows%20of%20seats%20and%20a%20glowing%20screen%2C%20amber%20and%20deep%20blue%20accents%2C%20editorial%20photography%2C%20cinematic%20atmosphere&width=800&height=600&seq=cat-movie-41&orientation=landscape",
  },
  {
    type: "tv",
    title: "电视剧频道",
    desc: "热播剧集 · 口碑好剧",
    icon: "ri-tv-2-line",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20at%20night%20with%20a%20large%20tv%20screen%20glowing%20warm%20amber%20light%2C%20soft%20blue%20ambient%20tones%2C%20editorial%20photography%2C%20comfortable%20atmosphere&width=800&height=600&seq=cat-tv-42&orientation=landscape",
  },
  {
    type: "variety",
    title: "综艺频道",
    desc: "爆笑综艺 · 音乐竞演",
    icon: "ri-mic-line",
    image:
      "https://readdy.ai/api/search-image?query=vibrant%20concert%20stage%20with%20warm%20golden%20spotlights%20and%20crowd%20silhouettes%2C%20energetic%20amber%20and%20teal%20accents%2C%20editorial%20photography%2C%20lively%20atmosphere&width=800&height=600&seq=cat-variety-43&orientation=landscape",
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full px-4 py-10 md:px-6 md:py-12">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={`/category/${entry.type}`}
            className="group relative h-44 overflow-hidden rounded-lg border border-background-200"
          >
            <img
              src={entry.image}
              alt={entry.title}
              title={`${entry.title}入口`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col justify-end p-5">
              <span className="mb-2 flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className={`${entry.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-background-50">
                {entry.title}
              </h3>
              <p className="text-sm text-background-100/85">{entry.desc}</p>
            </div>
            <span className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur transition-colors group-hover:bg-accent-500">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}